<template>
  <div id="movement" class="networkshops-movement">
    <h2 class="vz-text-align-left">
      <strong>{{ title }}</strong>
      <p>{{ description }}</p>
    </h2>
    <div class="networkshops-movement-items">
      <div v-for="item of movementItems">
        <div>
          <b>{{ item.title }}</b>
          <ul>
            <li v-for="text in item.textList">
              {{ text }}
            </li>
          </ul>
        </div>
        <NuxtImg :src="item.icon" format="webp" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const props = defineProps({
  isMarketplaces: {
    type: Boolean,
    default: false
  }
})

const data = (await getPageContent('/networkshops')).blocks?.movement

const title = computed(() => {
  return props.isMarketplaces 
    ? 'Движение в нужном направлении'
    : 'Закажите доставку в розничные сети'
})

const description = computed(() => {
  return props.isMarketplaces 
    ? 'Помогаем двигаться в направлении успеха, поддерживая доставку на высоком уровне' 
    : 'в транспортной компании  Vozovoz'
})

const movementItems = computed(() => [
  {
    title: props.isMarketplaces ? data.advantageousTitle : 'Выгодные опции доставки',
    textList: data.advantageousList.split(';'),
    icon: '/images/pages/networkshops/advantages.png'
  },
  {
    title: props.isMarketplaces ? data.modernTitle : 'Стоимость и документы онлайн',
    textList: data.modernList.split(';'),
    icon: '/images/pages/networkshops/modern.png'
  },
  {
    title: props.isMarketplaces ? data.quickTitle : 'Соблюдение сроков',
    textList: data.quickList.split(';'),
    icon: '/images/pages/networkshops/quick.png'
  },
  {
    title: props.isMarketplaces ? data.professionallyTitle : 'В соответствии с требованиями сетей',
    textList: data.professionallyList.split(';'),
    icon: '/images/pages/networkshops/professionally.png'
  },
])
</script>

<style scoped lang="scss">
.networkshops-movement {
  margin-bottom: 110px;
  margin-top: 110px;

  h2 {
    strong {
      text-transform: uppercase;
      color: $primary;
    }
    p {
      margin-top: 8px;
    }
  }

  &-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    > div {
      display: flex;
      align-items: center;
      border: 1px solid $border-gray;
      border-radius: 4px;
      box-shadow: $pub-gray-box-shadow;
      background: $public-card-bg;

      > div {
        margin: 30px 40px;

        b {
          font-size: $fs-18;
        }
        ul {
          margin-top: 10px;
          color: $font-low;
          list-style: inside;
        }
      }
      > img {
        margin: 16px 10px;
      }
    }
  }

  @media screen and (max-width: $pub-md) {
    margin-bottom: 90px;
    margin-top: 90px;
  }
  @media screen and (max-width: $pub-sm) {
    margin-bottom: 70px;
    margin-top: 70px;
    &-items {
      > div {
        flex-direction: column-reverse;
        justify-content: flex-end;
        > div {
          margin: 10px 30px 30px;
        }
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-items {
      grid-template-columns: 1fr;
    }
  }
}
</style>
